export const EnvConfig = {
  siteUrl: import.meta.env.PUBLIC_SITE_URL || "https://orha.online",
  siteName: import.meta.env.PUBLIC_SITE_NAME || "Орха",
  siteDesc: import.meta.env.PUBLIC_SITE_DESC || "",
  dev: import.meta.env.DEV,
  prod: import.meta.env.PROD,
};
